import styled from 'styled-components';

type BadgeProps = {
  dealType?: string;
  fontSize?: number;
  backgroundColor?: string;
};

export const Badge = styled.div.attrs<BadgeProps>({
  className: 'badge',
})<BadgeProps>`
  margin: 5px;
  padding: 5px 10px 5px 10px;
  text-transform: uppercase;
  background-color: ${(props) => props.backgroundColor ?? props.theme.palette.purple};
  font-weight: ${(props) => props.theme.typography.fontWeights.semibold};
  ${(props) => props.fontSize && `font-size: ${props.fontSize}px`}
`;

type NumberBadgeProps = {
  backgroundColor?: string;
};

export const NumberBadge = styled.div.attrs({
  className: 'badge',
})<NumberBadgeProps>`
  background-color: ${(props) => (props) => props.backgroundColor || props.theme.palette.gray};
  min-width: 24px !important;
  height: 18px !important;
  display: flex;
  justify-content: center !important;
  align-items: center !important;
  font-size: ${(props) => props.theme.typography.h5};
  font-weight: ${(props) => props.theme.typography.fontWeights.semibold};
  color: ${(props) => props.color || props.theme.palette.dusty};
  margin-top: 4px;
  border-radius: 2px;
`;

export const PortfolioBadge = styled(Badge)`
  margin-top: 0px;
  margin-left: 5px;
  border-radius: 4px;
  padding-top: 7px;
  padding-bottom: 7px;
  margin-right: 5px;
  line-height: 4px;
  font-size: ${(props) => props.theme.typography.h6}px;
`;
